import type { PropsWithChildren } from "react";
import React from "react";

import clsx from "clsx";

import { Container } from "@busbud/horizon";

interface Props {
  className?: string;
  wrapperClassName?: string;
  topBorder?: boolean;
}

export const FooterBaseSection: React.FC<PropsWithChildren<Props>> = ({
  className,
  wrapperClassName,
  children,
  topBorder = true
}) => {
  return (
    <Container
      className={clsx(
        {
          "sm:border-t-width-sm sm:border-t-color-primary": topBorder
        },
        wrapperClassName
      )}
    >
      <div
        className={clsx(
          "flex flex-1 justify-center px-200 py-300 sm:px-0",
          className
        )}
      >
        {children}
      </div>
    </Container>
  );
};
